import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {SidepanelModalService} from "@app/sidepanel/services/sidepanel-modal.service";
import {BsModalRef} from "ngx-bootstrap";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {
    CommunicationDispatcherService
} from "@app/shared/communication-mapping/services/communication-dispatcher.service";
import {Subscription} from "rxjs";
import {InputModel} from "@app/shared/communication-mapping/services/input-model";
import {CommunicationHelperService} from "@app/shared/communication-mapping/services/communication-helper.service";
import {AppValidators, CsModalComponent} from "@app/directives";
import {
    CommunicationContainerComponent
} from "@app/shared/communication-mapping/container/communication-container.component";
import {AuthService} from "@app/core";

@Component({
    selector: 'app-communication-segment',
    templateUrl: './communication-segment.component.html',
    styleUrls: ['./communication-segment.component.scss']
})
export class CommunicationSegmentComponent implements OnInit {

    loading:boolean =true;
    subscription: Subscription;
    inputModel: InputModel;
    optionFullFilled:any=false;
    @ViewChild('allocationCloneModal') cloneAllocationsModal: CsModalComponent;
    @ViewChild('right_panel') addEditSegmentationPanel: any;

    segmentationSetupForm: FormGroup;
    segmentations: Array<{
        category: string;
        categoryName:string;
        searchText: string;
        activeItem: string | number;
        selected: boolean;
        AnySeleted:boolean;
        process: string;
        listItems: { id: number | string; text: string; selected:boolean }[];
        listItemsFiltered: { id: number | string; text: string; selected:boolean }[];
    }> = [];

    possibleSegCategories: any = []; // seg cat
    possibleSeg2Categories: any = [];  // seg cat without seg1 val
    segmentationSetupSaving = false;
    list:any=[];
    getSegCategoriesList:any;
    cloneAllocationsForm: FormGroup;
    configuredLTCList: Object[] = [];
    cloneAllocationsSelect2Config: Object = {
        placeholder: '',
        multiple: true,
        width: '100%',
        data: []
    };
    cloneAllocationsModalIsOpen:boolean=false;
    @Input() screenType:any;
    secondarySegmentation = false;
    segmentationEditAccess = false;
    opportunityScreen = false;
    constructor(
        private fb: FormBuilder,
        private modalService: SidepanelModalService,
        public bsSideModalRef: BsModalRef,
        private eventDispatcher: CommunicationDispatcherService,
        private helperService: CommunicationHelperService,
        private authService: AuthService,
    ) { }

    ngOnInit() {
        this.secondarySegmentation = this.authService.permitted(['SetupSecondarySegmentation.readaccess']) === true;
        this.segmentationEditAccess = this.authService.permitted(['SetupSecondarySegmentation.writeaccess']) === true;
        if( this.screenType === 'send_proposal_template' || this.screenType === 'on_way_notification_template' ||
            this.screenType === 'work_address_confirmation_template' || this.screenType === 'customer_confirmation_template' ) {
            this.opportunityScreen = true;
        }
        this.segmentations = [
            {selected : false,AnySeleted:false,category:'',categoryName:'',listItems:[],process:'loading',searchText:'',activeItem:0,listItemsFiltered:[]},//api
            {selected : false,AnySeleted:false,category:'',categoryName:'',listItems:[],process:'loading',searchText:'',activeItem:0,listItemsFiltered:[]} //api
        ];

        this.cloneAllocationsForm = this.fb.group({
            'sourceSegmentLevel': ['', [Validators.required]],
            'targetValues': [[], [AppValidators.nonEmptylistValidator]]
        });

        this.subscription = this.eventDispatcher.triggerEvent$.subscribe({
            next: (data: any) => {
                if (typeof data != 'object' || !data['actionName']) {
                    return;
                }
                const action = data['actionName'];
                /* Initial load */
                if (action == 'event:loadedData') {
                    const value = data['data'];
                    this.inputModel = value['inputModel'];
                    this.possibleSegCategories = value['layoutComponent'].possibleSegCategories
                    this.getSegCategoriesList = value['layoutComponent'].getSegCategoriesList;
                    this.openLabourTab(this.inputModel);

                    this.segmentSelection(0,-1)
                    this.segmentSelection(1,-1)

                    this.loading= false;
                }
                if (action == 'event:updateFormValue'){
                    const value = data['for'];
                    for (let i = 1; i < 3; i++) {
                        const index = this.segmentations[i-1].listItems.findIndex(el => el.id === this.inputModel['activeSegmentationValue'+i]);
                        if (index != -1 && value && value != "clone" && value != "update") this.segmentations[i-1].listItems[index].selected = !this.segmentations[i-1].listItems[index].selected;
                        else{
                            if (index != -1 && value && value == "update") this.segmentations[i-1].listItems[index].selected = true;
                            if (index != -1 && data.from == "clearOption"){
                                if( data.inputModel.templates.some((obj :any) => {obj.segmentationValue1 == data.inputModel.activeSegmentationValue1 && obj.segmentationValue2 == data.inputModel.activeSegmentationValue2})) {
                                    this.segmentations[i-1].listItems[index].selected = true;
                                }
                                else{
                                    this.segmentations[i-1].listItems[index].selected = false;
                                }
                            }

                        }

                    }
                    this.segmentSelection();
                    this.loading= false;
                }
            }
        });

        this.segmentationSetupForm = this.fb.group({
            'segmentation_1': ['', [Validators.required]],
            'segmentation_2': ['', ]
        });

    }

    segmentSelection(seg:number = null,id:number=null){
        if(seg != null){
            this.segmentations[seg].activeItem = id;
            this.inputModel['activeSegmentationValue'+(seg+1)] = id;

            if(this.inputModel && this.inputModel.settings.allowSegmentation){
                if(this.inputModel.templates.find((obj:any) => (obj['segmentationValue'+(seg+1)] == -1))){
                    this.segmentations[seg].AnySeleted = true;
                }
                else{
                    this.segmentations[seg].AnySeleted = false;
                }
            }
        }
        const filteredInput = this.inputModel['templates'].filter((c:any) => parseInt(c.segmentationValue1) == this.segmentations[0].activeItem && parseInt(c.segmentationValue2) == this.segmentations[1].activeItem);
        this.optionFullFilled = (filteredInput.length > 0 && this.segmentations[0].category == this.inputModel.segmentationType1 && this.segmentations[1].category == this.inputModel.segmentationType2);
        var type = '';
        if(this.optionFullFilled){
            type = filteredInput.length > 1 ? (filteredInput[0]['communicationType'] == 'email' ? filteredInput[0]['communicationType']:filteredInput[1]['communicationType']):filteredInput[0]['communicationType'] ;
            const emailTitle = filteredInput.find((i: any) => i.communicationType == 'email');
            const smsTitle = filteredInput.find((i: any) => i.communicationType == 'sms');
            this.inputModel['title'] = [emailTitle ? emailTitle['title'] :'',smsTitle ? smsTitle['title'] :''];
            this.eventDispatcher.dispatchEvent(CommunicationDispatcherService.CONSTANTS['updateTemplateDetails'], {
                type,
                value: filteredInput[0],
                inputModel: this.inputModel,
                multiValue: filteredInput,
                from:'segmentSelected'
            });
        }else{
            this.inputModel['title'] = ''
            this.eventDispatcher.dispatchEvent(CommunicationDispatcherService.CONSTANTS['updateTemplateDetails'], {
                type,
                value: {segmentations:this.segmentations},
                inputModel: this.inputModel,
                from:'segmentSelected'
            });
        }
    }

    deleteSegment(seg:number){

        if(seg == 0 ){
            this.segmentations[0].selected = this.segmentations[1].selected;
            this.segmentations[0].category = this.segmentations[1].category;
            this.segmentations[0].categoryName = this.segmentations[1].categoryName;
            this.segmentations[0].listItems = this.segmentations[1].listItems;
            this.segmentations[0].listItemsFiltered = this.segmentations[1].listItemsFiltered;
            this.segmentationSetupForm.value['segmentation_1'] = this.segmentationSetupForm.value['segmentation_2'];
            this.inputModel.segmentationType1 = this.inputModel.segmentationType2
        }

        this.segmentations[1].selected = false;
        this.segmentations[1].category = null;
        this.segmentationSetupForm.value['segmentation_2'] = '';
        this.inputModel.segmentationType2=null;
        if(!this.segmentations[0].selected && !this.segmentations[1].selected){
            this.inputModel.templates = [];
        }

        this.segmentations[0].listItems = this.segmentations[0].listItems.map(item => {return { ...item, selected: false}});
        this.segmentations[0].listItemsFiltered = this.segmentations[0].listItems;
        this.inputModel.templates = this.inputModel.templates.filter( obj => { return (obj['segmentationValue1'] == "-1" && obj['segmentationValue2'] == "-1")})
        this.segmentSelection(seg,-1);
    }

    openSidepanel() {
        const patchValue = {
            'segmentation_1': '',
            'segmentation_2': ''
        };

        if (this.segmentations.length) {
            patchValue['segmentation_1'] = this.segmentations[0].selected ? this.segmentations[0].category : '';
            this.possibleSeg2Categories = this.possibleSegCategories.filter((c:any) => c['value'] !== this.segmentations[0].category);

            if (this.segmentations.length > 1) {
                patchValue['segmentation_2'] = this.segmentations[1].selected ? this.segmentations[1].category : '';
            }
        }

        this.segmentationSetupForm.patchValue(patchValue);
        this.segmentationSetupForm.updateValueAndValidity();
        this.bsSideModalRef = this.modalService.show(this.addEditSegmentationPanel, {});
        setTimeout( ()=>{
            if (this.opportunityScreen && !this.segmentationEditAccess) {
                $('#secondarySegment').prop('disabled', true);
            } else {
                $('#secondarySegment').prop('disabled', false);
            }
        }, 500);

    }
    onSidepanelClose() {
        if(this.bsSideModalRef.content == null){
            this.bsSideModalRef.hide();
        }
    }

    openLabourTab(input:any=false){

        var seg = [input?input.segmentationType1:this.segmentationSetupForm.value['segmentation_1'],input?input.segmentationType2:this.segmentationSetupForm.value['segmentation_2']]
        if(seg[0] != this.inputModel.segmentationType1 || seg[1] != this.inputModel.segmentationType2 ){
            this.inputModel.templates=this.inputModel.templates.filter( (obj:any) => {return obj.segmentationValue1 == -1 && obj.segmentationValue2 == -1});
            const emailTitle = this.inputModel.templates.find((i: any) => i.communicationType == 'email');
            const smsTitle = this.inputModel.templates.find((i: any) => i.communicationType == 'sms');
            this.inputModel['title'] = [emailTitle ? emailTitle['title'] :'',smsTitle ? smsTitle['title'] :''];
            this.optionFullFilled = this.inputModel.templates.length > 0 ? this.optionFullFilled : false;
            this.segmentations[0].activeItem = this.segmentations[1].activeItem = -1;
        }
        for (var i in seg) {
            this.segmentations[i].categoryName = seg[i] ? this.possibleSegCategories.find((x:any) => x.value == seg[i])['value']: '';
            this.segmentations[i].category = seg[i]
            this.inputModel[`segmentationType${parseInt(i) + 1}`] = this.segmentations[i].category;
        }
        this.segmentations[0].selected = seg[0] ? true : false;
        this.segmentations[1].selected = seg[0] && seg[1] ? true : false;

        // this.inputModel.templates=[];

        this.eventDispatcher.dispatchEvent(CommunicationDispatcherService.CONSTANTS['updateTemplateDetails'], {
            inputModel: this.inputModel
        });
        this.getSegCategoriesList(seg[0],(val)=>this.setSegCategoriesList(0,val,input.templates))
        this.getSegCategoriesList(seg[1],(val)=>this.setSegCategoriesList(1,val,input.templates))
        this.segmentSelection();
        this.onSidepanelClose();
    }
    setSegCategoriesList(index,val,input){
        if(input){
            input.map((todo, i) => {
                if (todo['segmentationValue'+(index+1)] != null){
                    let itemIndex = val.listItems.findIndex(item => item.id == parseInt(todo['segmentationValue'+(index+1)]));
                    if(itemIndex != -1){
                        val.listItems[itemIndex].selected = true;
                    }
                }
            });
        }
        this.segmentations[index]['listItems'] = this.segmentations[index]['listItemsFiltered'] = val.listItems;

        this.segmentations[index]['process'] = (val.process === '' || val.process === 'loading') ? val.process = 'loading' : val.process = 'loaded';

    }


    checkSegmentation($event:any) {
        this.possibleSeg2Categories = this.possibleSegCategories.filter((c:any) => c['value'] !== $event.target.value);

        const seg2Control = this.segmentationSetupForm.controls['segmentation_2'];
        if ($event.target.value == '' || $event.target.value == seg2Control.value) {
            seg2Control.setValue('');
            seg2Control.updateValueAndValidity();
        }
    }

    onSegLineItemSearch(segIndex){
        this.segmentations[segIndex].listItemsFiltered = this.segmentations[segIndex].listItems
            .filter(i => (new RegExp(this.segmentations[segIndex].searchText, 'i')).test(i.text));
    }

    openCloneModal(segIndex: number, value) {


        this.cloneAllocationsForm.patchValue({
            'sourceSegmentLevel': segIndex,
            'targetValues': []
        });

        this.cloneAllocationsSelect2Config['data'] = this.segmentations[segIndex].listItems.filter(item => item.id !== value);

        this.cloneAllocationsModalIsOpen = true;
        this.cloneAllocationsModal.open();
    }

    onCloneClick(segIndex: number, value) {
        event.stopPropagation();
        this.openCloneModal(segIndex, value);
    }

    onCloneTargetSegmentSelect(event) {
        this.cloneAllocationsForm.controls['targetValues'].setValue(event);
        this.cloneAllocationsForm.controls['targetValues'].markAsTouched();
        this.cloneAllocationsForm.controls['targetValues'].updateValueAndValidity();
    }

    cloneAllocations() {
        const result  = this.inputModel['templates'].filter(item => (item.segmentationValue1 == this.segmentations[0].activeItem && item.segmentationValue2 == this.segmentations[1].activeItem));
        for (var val of this.cloneAllocationsForm.value.targetValues) {
            var foundIndex = this.segmentations[this.cloneAllocationsForm.value.sourceSegmentLevel].listItemsFiltered.findIndex(x => x.id == val);
            this.segmentations[this.cloneAllocationsForm.value.sourceSegmentLevel].listItemsFiltered[foundIndex].selected = true;
            this.segmentations[this.cloneAllocationsForm.value.sourceSegmentLevel].listItems[foundIndex].selected = true;
        }
        this.segmentations[this.cloneAllocationsForm.value.sourceSegmentLevel].listItemsFiltered = this.segmentations[this.cloneAllocationsForm.value.sourceSegmentLevel].listItems
        this.eventDispatcher.dispatchEvent(CommunicationDispatcherService.CONSTANTS['cloneData'], {
            data: {'list':result,'segmentationDetails':this.cloneAllocationsForm.value},
            inputModel: this.inputModel
        });
        this.cloneAllocationsModal.close();
    }

    onCloneModalClose() {
        this.cloneAllocationsForm.reset();
        this.cloneAllocationsModalIsOpen = false;
    }

    convertToTitleCase(input: string, type: string =''): string {
        // Split the string by underscores
        let words = input.split('_');
        let result ='';
        if(type === 'placeholder'){
            // Join the words back together with spaces
            result = words.join(' ').toLowerCase();
        }
        else{
            // Capitalize the first letter of the first word
            words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1).toLowerCase();

            // Join the words back together with spaces
            result = words.join(' ').toLowerCase();

            // Ensure the first word is properly capitalized
            result = result.charAt(0).toUpperCase() + result.slice(1);
        }
        return result;
    }

}
